import { render, staticRenderFns } from "./section-results-empty.vue?vue&type=template&id=32d74a4e&"
import script from "./section-results-empty.vue?vue&type=script&lang=js&"
export * from "./section-results-empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports